import { formatDate } from ".";

const valueTypeCheck = (value) => {
  return typeof value === "number" ? value.toString() : value === "" || value === null ? undefined : value;
};

export function setFormData(form) {
  let submitForm = JSON.parse(JSON.stringify(form));
  let cId = undefined;
  // submitForm.main.accountingType = submitForm.main.accountingCodeType ? submitForm.main.accountingCode : null;
  if (submitForm.main.accountingCode) {
    submitForm.main.accountingCode = submitForm.main.accountingCode.toString();
  }
  submitForm.main.personType = submitForm.others.formType;
  submitForm.main.personTypeId = form.main.personTypeId ? form.main.personTypeId.id : undefined;
  submitForm.main.deleteImage = form.main.deleteImage ?? false;
  if (form.main?.categoryId?.id) {
    cId = form.main.categoryId.id;
  } else if (form.main?.CategoryId) {
    cId = form.main.CategoryId;
  }
  submitForm.main.categoryId = cId;
  submitForm.main.is_public = form.others["is_public"];
  submitForm.main.buyPrice = parseFloat(submitForm.main.buyPrice);
  submitForm.main.sellPrice = parseFloat(submitForm.main.sellPrice);
  submitForm.main.buyTax = parseInt(submitForm.main.buyTax);
  submitForm.main.saleTax = parseInt(submitForm.main.saleTax);
  submitForm.main.barcode = submitForm.main.barcode ? submitForm.main.barcode.toString() : undefined;
  submitForm.main.code = submitForm.main.code ? submitForm.main.code.toString() : undefined;
  let others = [];
  if (["customer", "provider"]) {
    others.push({ isLegal: form.main.isLegal });
  }
  Object.keys(form.others).map((key, value) => {
    let input = {};
    input[key] = valueTypeCheck(form.others[key]);
    others.push(input);
    if (form.others.formType === "product") {
      submitForm.main.isProduct = 1;
    } else if (form.others.formType === "service") {
      submitForm.main.isProduct = 0;
    }
  });

  const formData = new FormData();
  formData.append("formData", JSON.stringify({ main: submitForm.main, others }));

  if (form.others.file) {
     //todo file Upload
    formData.append("file", form.others.file);
  }

  return formData;
}

export function setFinancialFormData(form) {
  let newForm = {
    ...form.others,
    ...form.main,
    financialType: form.others["formType"],
    currencyId: form.others?.priceUnitCurrency?.id,
    CurrencyId:form.main?.CurrencyId?.id,

    status: form.others.status && form.others.status == 1 ? 1 : 0
  };

  return newForm;
}
export function setPosFormData(form) {
  const newForm = {
    description: form.main.description,
    ip: form.main.ip,
    default: form.others.default === "1",
    FinancialId: form.main.FinancialId.id,
    title: form.main.title,
    port: parseFloat(form.main.port),
    currencyId: 1,
    type: form.main.type.id,
    financialType: "bank"
  }
  return newForm
}
export function setWarehouseFormData(form) {
  let newForm = { ...form.others, ...form.main, BranchId: form.others?.branch?.id };

  return newForm;
}

export function setUserFormData(form) {
  let newForm = {};
  const premissionIds = [];
  newForm["ePhone"] = form.main.ePhone;

  newForm["roleId"] = form.others.roleId.value;

  for (const property in form.others) {
    if (!isNaN(Number(property))) {
      if (form.others[property]) premissionIds.push(Number(property));
    }
  }

  newForm["permissionIds"] = premissionIds;

  newForm["accessTimeLimit"] = {
    enable: true,
    enableDateRange: form.others?.from ? true : false,
    enableHour: form.others?.fromHourMinute ? true : false,
    enableWeekday: form.others?.weekdays ? true : false,
    from: form.others?.from,
    to: form.others?.to,
    fromHourMinute: form.others?.fromHourMinute,
    toHourMinute: form.others?.toHourMinute,
    weekdays: form.others?.weekdays
  };

  return newForm;
}

export function setShareholderFormData(form) {
  let shareholders = {};
  form.map((form) => {
    shareholders["percent"] = form.others.sharePercent;
    shareholders["nickName"] = form.others.shareholder.nickName;
    shareholders["PersonId"] = form.others.shareholder.id;
  });
  return shareholders;
}

export function setFactorFormData(form) {
  let newForm = {};

  Object.keys(form.main).map((key, value) => {
    newForm[key] = form.main[key];
  });

  Object.keys(form.others).map((key, value) => {
    newForm[key] = form.others[key];
  });

  return newForm;
}

export function setProjectFormData(form) {
  let newForm = {};

  Object.keys(form.main).map((key, value) => {
    newForm[key] = form.main[key];
  });

  Object.keys(form.others).map((key, value) => {
    newForm[key] = form.others[key];
  });

  return newForm;
}

export function setBranchFormData(form) {
  let newForm = {};

  Object.keys(form.main).map((key, value) => {
    newForm[key] = form.main[key];
  });

  Object.keys(form.others).map((key, value) => {
    newForm[key] = form.others[key];
  });

  return newForm;
}

export function setCostCenterFormData(form) {
  let newForm = {};

  Object.keys(form.main).map((key) => {
    newForm[key] = key === "code" ? parseInt(form.main[key]) : form.main[key];
  });
  return newForm;
}

export function setFormDataTransfer(form) {
  let transfers = {};

  transfers["description"] = form.description;
  transfers["date"] = formatDate(form.date);
  transfers["ProjectId"] = form.Project?.id ?? null;
  transfers["BranchId"] = form.Branch?.id ?? null;
  transfers["accountingCode"] = form.accountingCode?.toString() ?? null;
  transfers["fromId"] = form?.from?.id ?? null;
  transfers["amount"] = +form.amount ?? null;
  transfers["from_wage"] = form.from_wage ? parseInt(form.from_wage) : null;
  transfers["to_wage"] = form.to_wage ? parseInt(form.to_wage) : null;
  transfers["from_reference"] = form.from_reference ?? null;
  transfers["to_reference"] = form.to_reference ?? null;
  transfers["toId"] = form?.to?.id ?? null;
  transfers["currencyId"] = form?.Currency?.id ?? null;
  transfers["currencyExchange"] = 1;

  return transfers;
}

export function setFormDataInstallment(form) {
  const prepayment = () => {
    const factor = form?.factor;
    if (!factor) return 0;
    const prepaymentType = form?.prepaymentActive ? "percent" : "price";
    const prepaymentAmount = form?.prepayment;

    if (prepaymentType === "price") return prepaymentAmount ?? 0;
    return factor.totalPrice * (prepaymentAmount / 100);
  };
  const sumInstallments = () => {
    return (
      form?.source?.reduce((sum, item) => {
        return sum + +(item.price ?? 0);
      }, 0) ?? 0
    );
  };
  const profit = () => {
    const factor = form?.factor;
    if (!factor) return 0;
    const profitType = form?.profitActive ? "percent" : "price";
    const profitAmount = form?.profit;
    const prepaymentAmount = prepayment();

    if (profitType === "price") return profitAmount ?? "0";
    return (factor.totalPrice - prepaymentAmount) * (profitAmount / 100);
  };
  const totalPayment = () => {
    const factor = form?.factor;
    if (!factor) return 0;
    const installmentsAmount = sumInstallments();
    const prepaymentAmount = prepayment();
    return +prepaymentAmount + +installmentsAmount;
  };

  let installment = {};
  let installments = [];

  form.source.map((i) => {
    if (i.price && i.date) {
      installments.push(i);
    }
  });

  installment["factorId"] = form?.factor?.id ?? null;
  installment["projectId"] = form.Project?.id ?? null;
  installment["branchId"] = form.Branch?.id ?? null;
  installment["prepayment"] = +prepayment();
  installment["profit"] = +profit();
  installment["quantity"] = +form.quantity;
  installment["interval"] = +form.interval;
  installment["description"] = form.description;
  installment["totalPaid"] = +totalPayment();
  installment["installments"] = installments;

  return installment;
}

export function setFormDataProfile(form) {
  let formData = {};

  formData["firstName"] = form.main.firstName;
  formData["lastName"] = form.main.lastName;
  formData["phone"] = form.main.phone;
  formData["email"] = form.main.email;

  return formData;
}

//todo fix percent conditions
export function setManufacturingFormData(form) {
  let formData = { main: {}, products: [] };

  formData.main["accountingCode"] = form.accountingCode ?? null;
  formData.main["title"] = form.title;
  formData.main["ProductId"] = form.productId;
  formData.main["estimateCost"] = form.cost || 0;
  formData.main["estimateCostType"] = form.costType;
  formData.main["estimateWage"] = form.wage || 0;
  formData.main["estimateWageType"] = form.wageType;

  formData.products = form.materialsRows.map((material) => {
    return {
      productId: material.productId,
      unit: material.unit,
      quantity: material.quantity
    };
  });

  return formData;
}

export function setManufacturingOrderFormData(form) {
  let formData = { main: {}, products: [], overHeads: [], wages: [] };

  formData.main["accountingCode"] = form.accountingCode ?? null;
  formData.main["date"] = form.date;
  formData.main["description"] = form.description;
  formData.main["unit"] = form.quantityUnit;
  formData.main["quantity"] = Number(form.quantity);
  formData.main["status"] = form.status;
  formData.main["optionableId"] = form.optionableId;
  formData.main["optionableType"] = form.optionableType;
  formData.main["price"] = form.finalPrice;
  formData.main["ProductId"] = form.productId;
  formData.main["ProjectId"] = form.projectId;
  formData.main["ProductionFormulaId"] = form.formulaId;
  formData.main["BranchId"] = form.branchId;
  formData.main["WarehouseId"] = form.remmitanceWarehouseId;
  formData.main["CurrencyId"] = form.CurrencyId;
  formData.main["CurrencyExchange"] = form.CurrencyExchange;

  formData.products = form.materialsRows.map((material) => {
    return {
      ProductId: material.ProductId,
      unit: material.unit,
      quantity: Number(material.quantity),
      WarehouseId: material.warehouseId,
      totalPrice: material.totalPrice,
      price: material.unitPrice
    };
  });

  formData.overHeads = form.costs.map((item) => {
    return {
      type: item.type,
      value: item.value,
      amount: item.amount,
      isCreditor: item.isCreditor,
      accountTypeId: item.accountTypeId
    };
  });

  formData.wages = form.wages.map((item) => {
    return {
      type: item.type,
      value: item.value,
      amount: item.amount,
      isCreditor: item.isCreditor,
      accountTypeId: item.accountTypeId
    };
  });

  formData.autoBill = form.automaticRemmitance;

  return formData;
}
